import FieldConfig from "../../../../fields3/proto/field-config"
import FieldProjectType_Editable from "./render/editable/editable"
import {ProjectSystemType, ProjectSystemTypeIcon, ProjectSystemTypeName} from "../../../../model2/project/types"
import FieldProjectType_TableCell from "./render/table/table-cell";
import FieldDropdown from "../../../generic/dropdown/dropdown";
import ProjectSession from "../../../../model2/project/project-session";
import {FieldDropdown_filterValuesFiller} from "../../../conditions/dropdown";
import FieldProjectType_GraphTickLabelView from "./render/graph-tick-label"
import ModelEntity from "../../../../model2/model-entity"

export default class FieldProjectType extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config)


        this.typeLabel                  = "Project System Type"
        this.icon                       = "i5-type"
        this.isFilterAvailable          = true
        this.showConditionsNotSetOption = false

        this.noValueOptionLabel         = _.get(config, 'noValueOptionLabel', ProjectSystemTypeName[ProjectSystemType.FOLDER])

        if (!config.options || config.options.length < 1) {
            this.options = [{
                value   : ProjectSystemType.FOLDER,
                label   : "Folder",
                icon    : "i5-folder"
            }]

            gd.session.templatesList.models.map((template: ProjectSession)=> {
                this.options!.push({
                    value   : template.id,
                    label   : template.name,
                    icon    : template.icon
                })
            })
        }

        this.renderComponents.editable              = FieldProjectType_Editable
        this.renderComponents.tableCell             = FieldProjectType_TableCell
        this.renderComponents.graphTickLabelView    = FieldProjectType_GraphTickLabelView
        this.filterValuesFiller                     = FieldDropdown_filterValuesFiller
    }

    public _getOption(value: any, model?: ModelEntity): any {
        const option = super._getOption(value, model)
        if (option) return option

        // When localTemplateId is null, group/label by systemType (Project, Backlog, Sprint, etc.)
        const systemTypeLabel = ProjectSystemTypeName[value as ProjectSystemType]
        if (systemTypeLabel) {
            const iconName = ProjectSystemTypeIcon[value as ProjectSystemType]
            return {
                value,
                label   : systemTypeLabel,
                icon    : iconName ? "i5-" + iconName : undefined,
            }
        }

        return false
    }

    getViewValue(model:any) {
        let res

        const template = gd.session.templatesList.get(model.localTemplateId)
        if (template) {
            res = template.name
        } else {
            // @ts-ignore
            res = ProjectSystemTypeName[model.systemType]
        }

        return res
    }
}
